import { Component, Input, OnInit } from '@angular/core';
import { SavedParcel, SavedPin } from '@models/teranet';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { SalePinState } from '@state/sale_pins';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';

@UntilDestroy()
@Component({
	selector: 'app-parcel-name-compare',
	templateUrl: './parcel.component.html',
	styleUrls: ['./parcel.component.scss'],
	standalone: false,
})
export class ParcelCompareComponent implements OnInit {
	public ICON = ICON;
	public pin: SavedPin;
	public parcel: SavedParcel;

	@Input() Pin: string;
	@Input() showSimilar: boolean;
	@Input() primary = false;

	@SelectSnapshot(SelectedMatter.id) saleId;
	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	@Select(SalePinState.getPin) selectedPin$: Observable<any>;

	ngOnInit(): void {
		this.selectedPin$
			.pipe(
				untilDestroyed(this),
				map((filterFn) => filterFn(this.Pin)),
			)
			.subscribe((pin) => {
				if (pin) {
					this.pin = pin;
					if (pin?.parcels && pin.parcels?.length > 0) {
						this.parcel = pin.parcels[0];
					}
				}
			});
	}
}
